import {OTPInput} from "../app/OTPInput";

addEventListener('DOMContentLoaded', (event) => {
    (new OTPInput()).init();
});